import { addDays, differenceInDays } from 'date-fns';

export const getIsEntitlementHealthy = (
  startDate: Date,
  endDate: Date,
  entitlement: number,
  remaining: number,
  currentDate: Date = new Date(),
) => {
  const entitlementYearLength = differenceInDays(addDays(endDate, 1), startDate);
  const entitlementDepletionRate = entitlement / entitlementYearLength;
  const tolerance = 0.1;
  const daysIntoHolidayYear = differenceInDays(currentDate, startDate);
  const expectedRemainingOnCurrentDay =
    entitlement - daysIntoHolidayYear * entitlementDepletionRate;

  const currentDaysTriggerLevel =
    expectedRemainingOnCurrentDay + expectedRemainingOnCurrentDay * tolerance;

  return remaining < currentDaysTriggerLevel;
};
